<!-- 证书查询 -->
<template>
  <div class="frame">
    <div class="banner">
      <img src="@/assets/zscxbj.jpg" alt="" />
    </div>
    <div class="container">
      <div class="list" v-show="step == 'select'">
        <div class="item" v-for="item in subjects" :key="item.code">
          <img :src="item.icon" alt="" class="icon" />
          <div class="title">{{ item.name }}</div>
          <button class="search" @click="changeStepToForm(item.code)">
            查看
          </button>
        </div>
      </div>
      <div class="form-box" v-show="step == 'form'">
        <el-form :model="queryParams" :rules="queryRules" label-width="100px">
          <el-form-item label="姓名">
            <el-input
              v-model="queryParams.userName"
              placeholder="输入查询的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证">
            <el-input
              v-model="queryParams.idNo"
              placeholder="输入查询的身份证号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="证书类型">
            <el-input
              v-model="queryParams.subjectName"
              placeholder="选择证书类型"
              readonly
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="menus">
          <el-button class="btn" type="text" @click="backSelect"
            >返回重选</el-button
          >
          <el-button
            class="btn"
            type="primary"
            :loading="loading"
            @click="startSearch"
            >立即查询</el-button
          >
        </div>
      </div>
      <div class="table" v-show="step == 'table'">
        <div class="title">证书列表</div>
        <div class="back">
          <el-button type="text" icon="el-icon-arrow-left" @click="backToForm"
            >返回</el-button
          >
        </div>
        <el-table :data="list" border>
          <el-table-column
            label="姓名"
            prop="userName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="身份证"
            prop="idNo"
            align="center"
          ></el-table-column>
          <el-table-column
            label="证书类型"
            prop="subjectName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="专业名称（岗位、工种）"
            prop="workTypeName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="证书编号"
            prop="certNum"
            align="center"
          ></el-table-column>
          <el-table-column label="是否培训" align="center">
            <template>已培训</template>
          </el-table-column>
          <el-table-column label="考试结果" align="center">
            <template>通过</template>
          </el-table-column>
          <el-table-column
            label="证书有效期"
            prop="certExpirationTime"
            align="center"
          ></el-table-column>
          <el-table-column
            label="工作单位"
            prop="companyName"
            align="center"
          ></el-table-column>
          <el-table-column label="电子证书" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                icon="el-icon-download"
                @click="downloadCert(row)"
                >下载证书</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ip } from "../util/config";
export default {
  data() {
    return {
      step: "select",
      subjects: [
        {
          name: "职业技能人员信息",
          code: "ZYJN",
          icon: require("../assets/zscx1.png"),
        },
        {
          name: "职业资格人员信息",
          code: "ZYZG",
          icon: require("../assets/zscx2.png"),
        },
        {
          name: "专业技术人员信息",
          code: "ZYJS",
          icon: require("../assets/zscx3.png"),
        },
        {
          name: "工程机械技术人员信息",
          code: "GCJX",
          icon: require("../assets/zscx4.png"),
        },
      ],
      queryParams: {
        userName: "", // 姓名
        idNo: "", // 身份证
        subjectCode: "", // 证书类型
        subjectName: "",
      },
      queryRules: {},
      list: [],
      loading: false,
    };
  },
  methods: {
    changeStepToForm(type) {
      let subject = this.subjects.find((ele) => ele.code == type);
      this.queryParams.subjectCode = subject.code;
      this.queryParams.subjectName = subject.name;
      this.step = "form";
    },
    backSelect() {
      Object.assign(this.$data.queryParams, this.$options.data().queryParams);
      this.step = "select";
    },
    startSearch() {
      this.loading = true;
      this.$api.queryCertification(this.queryParams).then((res) => {
        this.loading = false;
        this.list = res.data;
        this.step = "table";
      });
    },
    // 下载证书
    downloadCert(row) {
      // 下载证书api
      axios
        .get(ip + "jianxie/certificate-apply-form/front/getcertApplyPdf", {
          params: { certNum: row.certNum },
          responseType: "blob",
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          let fileReader = new FileReader();
          fileReader.readAsText(res.data);
          fileReader.onload = (result) => {
            try {
              // 返回的报错信息
              let jsondata = JSON.parse(result.target.result);
              if (jsondata.code != 0) {
                this.$notify.error({ title: jsondata.msg });
                return;
              }
            } catch (error) {
              // 返回的base64
              let url = window.URL.createObjectURL(res.data);
              let a = document.createElement("a");
              a.href = url;
              a.download = row.certNum + ".pdf";
              a.click();
            }
          };
        });
    },
    // 返回至查询表单步骤
    backToForm() {
      this.step = "form";
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-color: #1c44b5;
  text-align: center;
}
.container {
  width: 1200px;
  margin: 0 auto;
  min-height: 450px;
  position: relative;

  &::before {
    content: "";
    display: table;
  }

  .list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .item {
    width: 20%;
    height: 300px;
    box-shadow: 0 0 5px #999;
    border-radius: 6px;
    text-align: center;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #484848;
    transition: 0.5s;

    &:hover {
      transform: scale(1.1);
      background-color: #c7eae1;
    }

    .icon {
      width: 65%;
    }
    .search {
      width: 100px;
      line-height: 32px;
      margin-top: 20px;
      background-color: #1b43b4;
      color: #fff;
      border-radius: 5px;
      outline: none;
      border: none;
      cursor: pointer;

      &:active {
        transform: scale(0.9);
      }
    }
  }

  .form-box {
    width: 600px;
    margin: 60px auto 0;
    box-shadow: 0 0 5px #999;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
  }
  .menus {
    display: flex;
    justify-content: center;
  }
  .btn {
    width: 200px;
  }

  .table {
    width: 1000px;
    margin: 60px auto 0;
    position: relative;

    .title {
      text-align: center;
      font-size: 25px;
      margin-bottom: 20px;
      font-weight: bold;
    }
    .back {
      position: absolute;
      left: 0;
      top: 0;
    }

    :deep(.el-table th.el-table__cell) {
      background-color: #f9fbfd !important;
      color: #385e7a;
    }
  }
}
</style>
